import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { meteorologico } from '../../store/actions/meteorologico'
import { suelo } from '../../store/actions/suelo'
import { tesla } from '../../store/actions/tesla'
import { riego } from '../../store/actions/riego'
import { entorno } from '../../store/actions/entorno'
import { aguaSalada } from '../../store/actions/aguaSalada'
import { aguaDulce } from '../../store/actions/aguaDulce'
import { meteorologicoNodo } from '../../store/actions/meteorologicoNodo'
import { sueloNodo } from '../../store/actions/sueloNodo'
import { riegoNodo } from '../../store/actions/riegoNodo'
import { entornoNodo } from '../../store/actions/entornoNodo'
import { aguaSaladaNodo } from '../../store/actions/aguaSaladaNodo'
import { aguaDulceNodo } from '../../store/actions/aguaDulceNodo'
import { teslaNodo } from '../../store/actions/teslaNodo'
import React, { useState } from 'react';
import SensoresCard from '../../utils/MeteorologicCard';
import SueloCard from '../../utils/SueloCard';
import RiegoCard from '../../utils/RiegoCard';
import EntornoCard from '../../utils/EntornoCard';
import AguaDulceCard from '../../utils/AguaDulceCard';
import AguaSaladaCard from '../../utils/AguaSaladaCard';
import TeslaCard from '../../utils/TeslaCard';
import './styles.css'
import './datosSensor.css'
import Chart from './chart'
import ChartSalada from './chartSalada'
import ChartMeteorologico from './chartMeteorologico'
import ChartSuelo from './chartSuelo'
import ChartRiego from './chartRiego'
import ChartGases from './chartEntorno'
import ChartTesla from './chartTesla'
import { saveAs } from 'file-saver';
import Papa from 'papaparse';
import { coordenadas } from '../../store/actions/coordenadas'
import { useAuth } from "../../hoc/AuthContext";

const Home = () => {
    const { logout } = useAuth();
    const sensores = useSelector(state => state.meteorologico);
    const Riego = useSelector(state => state.riego);
    const Suelo = useSelector(state => state.suelo);
    const Entorno = useSelector(state => state.entorno);
    const Salada = useSelector(state => state.salada);
    const Dulce = useSelector(state => state.dulce);
    const Tesla = useSelector(state => state.tesla);
    const sensoresNodo = useSelector(state => state.meteorologicoNodo);
    const RiegoNodo = useSelector(state => state.riegoNodo);
    const SueloNodo = useSelector(state => state.sueloNodo);
    const EntornoNodo = useSelector(state => state.entornoNodo);
    const SaladaNodo = useSelector(state => state.saladaNodo);
    const DulceNodo = useSelector(state => state.dulceNodo);
    const TeslaNodo = useSelector(state => state.teslaNodo);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [visibleTablaMeteorologico, setVisibleTablaMeteorologico] = useState(false);
    const [visibleTablaRiego, setVisibleTablaRiego] = useState(false);
    const [visibleTablaSuelo, setVisibleTablaSuelo] = useState(false);
    const [visibleTablaEntorno, setVisibleTablaEntorno] = useState(false);
    const [visibleTablaSalada, setVisibleTablaSalada] = useState(false);
    const [visibleTablaDulce, setVisibleTablaDulce] = useState(false);
    const [visibleTablaTesla, setVisibleTablaTesla] = useState(false);

    const [visibleGraficaDulce, setVisibleGraficaDulce] = useState(false);
    const [visibleGraficaRiego, setVisibleGraficaRiego] = useState(false);
    const [visibleGraficaSuelo, setVisibleGraficaSuelo] = useState(false);
    const [visibleGraficaEntorno, setVisibleGraficaEntorno] = useState(false);
    const [visibleGraficaSalada, setVisibleGraficaSalada] = useState(false);
    const [visibleGraficaMeteorologico, setVisibleGraficaMeteorologico] = useState(false);
    const [visibleGraficaTesla, setVisibleGraficaTesla] = useState(false);

    const [visibleTablaDulceFiltrada, setVisibleTablaDulceFiltrada] = useState(false);
    const [visibleTablaRiegoFiltrada, setVisibleTablaRiegoFiltrada] = useState(false);
    const [visibleTablaSueloFiltrada, setVisibleTablaSueloFiltrada] = useState(false);
    const [visibleTablaEntornoFiltrada, setVisibleTablaEntornoFiltrada] = useState(false);
    const [visibleTablaSaladaFiltrada, setVisibleTablaSaladaFiltrada] = useState(false);
    const [visibleTablaMeteorologicoFiltrada, setVisibleTablaMeteorologicoFiltrada] = useState(false);
    const [visibleTablaTeslaFiltrada, setVisibleTablaTeslaFiltrada] = useState(false);

    const [visibleGraficaDulceNodo, setVisibleGraficaDulceNodo] = useState(false);
    const [visibleGraficaRiegoNodo, setVisibleGraficaRiegoNodo] = useState(false);
    const [visibleGraficaSueloNodo, setVisibleGraficaSueloNodo] = useState(false);
    const [visibleGraficaEntornoNodo, setVisibleGraficaEntornoNodo] = useState(false);
    const [visibleGraficaSaladaNodo, setVisibleGraficaSaladaNodo] = useState(false);
    const [visibleGraficaMeteorologicoNodo, setVisibleGraficaMeteorologicoNodo] = useState(false);
    const [visibleGraficaTeslaNodo, setVisibleGraficaTeslaNodo] = useState(false);


    const [botonActivo, setBotonActivo] = useState(1);

    const [lat, setLat] = useState(null);
    const [lon, setLon] = useState(null);

    const [isLoadingMeteorologico, setIsLoadingMeteorologico] = useState(true);
    const [isLoadingSuelo, setIsLoadingSuelo] = useState(true);
    const [isLoadingDulce, setIsLoadingDulce] = useState(true);
    const [isLoadingSalada, setIsLoadingSalada] = useState(true);
    const [isLoadingEntorno, setIsLoadingEntorno] = useState(true);
    const [isLoadingRiego, setIsLoadingRiego] = useState(true);
    const [isLoadingTesla, setIsLoadingTesla] = useState(true);

    // Estados de carga para cada llamada a la API
    const [isLoadingMeteorologicoNodo, setIsLoadingMeteorologicoNodo] = useState(true);
    const [isLoadingAguaDulceNodo, setIsLoadingAguaDulceNodo] = useState(true);
    const [isLoadingAguaSaladaNodo, setIsLoadingAguaSaladaNodo] = useState(true);
    const [isLoadingRiegoNodo, setIsLoadingRiegoNodo] = useState(true);
    const [isLoadingSueloNodo, setIsLoadingSueloNodo] = useState(true);
    const [isLoadingEntornoNodo, setIsLoadingEntornoNodo] = useState(true);
    const [isLoadingTeslaNodo, setIsLoadingTeslaNodo] = useState(true);
    const [mostrarPopup, setMostrarPopup] = useState(false);
    const [coordenadaSeleccionada, setCoordenadaSeleccionada] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingResultados, setIsLoadingResultados] = useState(false);
    const Coordenadas = useSelector(state => state.coordenadas.current);

    useEffect(() => {

        const isNodo = lat !== null && lon !== null;
        resetVistas();

        switch (botonActivo) {
            case 1:
                if (isNodo) {
                    setVisibleTablaDulceFiltrada(true);
                } else {
                    setVisibleTablaDulce(true);
                }
                break;
            case 2:
                if (isNodo) {
                    setVisibleGraficaDulceNodo(true);
                } else {
                    setVisibleGraficaDulce(true);
                }
                break;
            case 3:
                if (isNodo) {
                    setVisibleTablaEntornoFiltrada(true);
                } else {
                    setVisibleTablaEntorno(true);
                }
                break;
            case 4:
                if (isNodo) {
                    setVisibleGraficaEntornoNodo(true);
                } else {
                    setVisibleGraficaEntorno(true);
                }
                break;
            case 5:
                if (isNodo) {
                    setVisibleTablaSaladaFiltrada(true);
                } else {
                    setVisibleTablaSalada(true);
                }
                break;
            case 6:
                if (isNodo) {
                    setVisibleGraficaSaladaNodo(true);
                } else {
                    setVisibleGraficaSalada(true);
                }
                break;
            case 7:
                if (isNodo) {
                    setVisibleTablaRiegoFiltrada(true);
                } else {
                    setVisibleTablaRiego(true);
                }
                break;
            case 8:
                if (isNodo) {
                    setVisibleGraficaRiegoNodo(true);
                } else {
                    setVisibleGraficaRiego(true);
                }
                break;
            case 9:
                if (isNodo) {
                    setVisibleTablaMeteorologicoFiltrada(true);
                } else {
                    setVisibleTablaMeteorologico(true);
                }
                break;
            case 10:
                if (isNodo) {
                    setVisibleGraficaMeteorologicoNodo(true);
                } else {
                    setVisibleGraficaMeteorologico(true);
                }
                break;
            case 11:
                if (isNodo) {
                    setVisibleTablaSueloFiltrada(true);
                } else {
                    setVisibleTablaSuelo(true);
                }
                break;
            case 12:
                if (isNodo) {
                    setVisibleGraficaSueloNodo(true);
                } else {
                    setVisibleGraficaSuelo(true);
                }
                break;
            case 21:
                if (isNodo) {
                    setVisibleTablaTeslaFiltrada(true);
                } else {
                    setVisibleTablaTesla(true);
                }
                break;
            case 22:
                if (isNodo) {
                    setVisibleGraficaTeslaNodo(true);
                } else {
                    setVisibleGraficaTesla(true);
                }
                break;
            default:
                break;
        }
    }
    )

    useEffect(() => {
        if (sensores.sensores.length <= 0 && isLoadingMeteorologico) {
            setIsLoadingMeteorologico(true);
            dispatch(meteorologico(sensores)).finally(() => {
                setIsLoadingMeteorologico(false);
            });
        }
    }, [sensores.sensores, isLoadingMeteorologico]);  // Solo depende de `sensores.sensores`
    useEffect(() => {
        if (isLoadingSuelo) {
            setIsLoadingSuelo(true);
            dispatch(suelo(Suelo)).finally(() => {
                setIsLoadingSuelo(false);
            });
        }
    }, [Suelo, isLoadingSuelo]);  // Solo depende de `Suelo`
    useEffect(() => {
        if (isLoadingTesla) {
            setIsLoadingTesla(true);
            dispatch(tesla(Tesla)).finally(() => {
                setIsLoadingTesla(false);
            });
        }
    }, [Tesla, isLoadingTesla]);  // Solo depende de `Tesla`
    useEffect(() => {
        if (isLoadingDulce) {
            setIsLoadingDulce(true);
            dispatch(aguaDulce(Dulce)).finally(() => {
                setIsLoadingDulce(false);
            });
        }
    }, [Dulce, isLoadingDulce]);  // Solo depende de `Dulce`
    useEffect(() => {
        if (isLoadingSalada) {
            setIsLoadingSalada(true);
            dispatch(aguaSalada(Salada)).finally(() => {
                setIsLoadingSalada(false);
            });
        }
    }, [Salada, isLoadingSalada]);  // Solo depende de `Salada`
    useEffect(() => {
        if (isLoadingEntorno) {
            setIsLoadingEntorno(true);
            dispatch(entorno(Entorno)).finally(() => {
                setIsLoadingEntorno(false);
            });
        }
    }, [Entorno, isLoadingEntorno]);  // Solo depende de `Entorno`
    useEffect(() => {
        if (isLoadingRiego) {
            setIsLoadingRiego(true);
            dispatch(riego(Riego)).finally(() => {
                setIsLoadingRiego(false);
            });
        }
    }, [Riego, isLoadingRiego]);  // Solo depende de `Riego`
    useEffect(() => {
        setIsLoadingMeteorologicoNodo(true);
        dispatch(meteorologicoNodo({ lat, lon })).finally(() => {
            setIsLoadingMeteorologicoNodo(false);
        });
    }, [lat, lon]);  // Solo depende de `lat` y `lon`
    useEffect(() => {
        setIsLoadingAguaDulceNodo(true);
        dispatch(aguaDulceNodo({ lat, lon })).finally(() => {
            setIsLoadingAguaDulceNodo(false);
        });
    }, [lat, lon]);  // Solo depende de `lat` y `lon`
    useEffect(() => {
        setIsLoadingAguaSaladaNodo(true);
        dispatch(aguaSaladaNodo({ lat, lon })).finally(() => {
            setIsLoadingAguaSaladaNodo(false);
        });
    }, [lat, lon]);  // Solo depende de `lat` y `lon`
    useEffect(() => {
        setIsLoadingRiegoNodo(true);
        dispatch(riegoNodo({ lat, lon })).finally(() => {
            setIsLoadingRiegoNodo(false);
        });
    }, [lat, lon]);  // Solo depende de `lat` y `lon`
    useEffect(() => {
        setIsLoadingSueloNodo(true);
        dispatch(sueloNodo({ lat, lon })).finally(() => {
            setIsLoadingSueloNodo(false);
        });
    }, [lat, lon]);  // Solo depende de `lat` y `lon`
    useEffect(() => {
        setIsLoadingEntornoNodo(true);
        dispatch(entornoNodo({ lat, lon })).finally(() => {
            setIsLoadingEntornoNodo(false);

        });
    }, [lat, lon]);  // Solo depende de `lat` y `lon`
    useEffect(() => {
        setIsLoadingTeslaNodo(true);
        dispatch(teslaNodo({ lat, lon })).finally(() => {
            setIsLoadingTeslaNodo(false);

        });
    }, [lat, lon]);  // Solo depende de `lat` y `lon`

    useEffect(() => {
        if (isLoading) {
            setIsLoading(true);
            dispatch(coordenadas(Coordenadas)).finally(() => {
                setIsLoading(false);
                setIsLoadingResultados(true);
            });
        }
    }, [Coordenadas, isLoading]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        if (lat !== null && lat !== "") {
            params.set('lat', lat);
        } else {
            params.delete('lat');
        }

        if (lon !== null && lon !== "") {
            params.set('lon', lon);
        } else {
            params.delete('lon');
        }

        if (botonActivo !== null) {
            params.set('view', botonActivo);
        } else {
            params.delete('view');
        }

        navigate({ search: params.toString() }, { replace: true });
    }, [lat, lon, botonActivo]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const latParam = params.get('lat');
        const lonParam = params.get('lon');
        const viewParam = parseInt(params.get('view'));

        if (latParam) setLat(latParam);
        if (lonParam) setLon(lonParam);
        if (!isNaN(viewParam)) setBotonActivo(viewParam);
    }, []);

    const SearchDate = () => {
        if (visibleGraficaMeteorologico || visibleGraficaMeteorologicoNodo) {
            setBotonActivo(10);
            return;
        }

        if (visibleGraficaDulce || visibleGraficaDulceNodo) {
            setBotonActivo(2);
            return;
        }

        if (visibleGraficaSalada || visibleGraficaSaladaNodo) {
            setBotonActivo(6);
            return;
        }

        if (visibleGraficaTesla || visibleGraficaTeslaNodo) {
            setBotonActivo(22);
            return;
        }

        if (visibleGraficaRiego || visibleGraficaRiegoNodo) {
            setBotonActivo(8);
            return;
        }

        if (visibleGraficaSuelo || visibleGraficaSueloNodo) {
            setBotonActivo(12);
            return;
        }

        if (visibleGraficaEntorno || visibleGraficaEntornoNodo) {
            setBotonActivo(4);
            return;
        }

        if (visibleTablaMeteorologico || visibleTablaMeteorologicoFiltrada) {
            setBotonActivo(9);
            return;
        }

        if (visibleTablaDulceFiltrada || visibleTablaDulce) {
            setBotonActivo(1);
            return;
        }

        if (visibleTablaSaladaFiltrada || visibleTablaSalada) {
            setBotonActivo(5);
            return;
        }

        if (visibleTablaTeslaFiltrada || visibleTablaTesla) {
            setBotonActivo(21);
            return;
        }

        if (visibleTablaRiegoFiltrada || visibleTablaRiego) {
            setBotonActivo(7);
            return;
        }

        if (visibleTablaSueloFiltrada || visibleTablaSuelo) {
            setBotonActivo(11);
            return;
        }

        if (visibleTablaEntornoFiltrada || visibleTablaEntorno) {
            setBotonActivo(3);
            return;
        }
    };

    useEffect(() => {
        const descargarCSV = async () => {
            if (!coordenadaSeleccionada) return;

            const { lat, lon } = coordenadaSeleccionada;
            const endpoints = [
                'getAguaDulceNodo',
                'getMeteorologicoNodo',
                'getTeslaNodo',
                'getRiegoNodo',
                'getEntornoNodo',
                'getSueloNodo',
                'getSaladaNodo'
            ];

            try {
                let datosValidos = null;

                for (let endpoint of endpoints) {
                    const response = await fetch(`/api/sensor/${endpoint}?lat=${lat}&lon=${lon}`);
                    const data = await response.json();

                    // Si hay datos válidos en la primera posición
                    if (data && Array.isArray(data[0]) && data[0].length > 0) {
                        datosValidos = data[0];
                        break;
                    }
                }

                if (datosValidos) {
                    const csv = Papa.unparse(datosValidos, {
                        delimiter: ";",
                        header: true,
                        skipEmptyLines: true
                    });

                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    saveAs(blob, `nodo_${lat}_${lon}.csv`);
                } else {
                    alert("No se encontró información en ninguna de las consultas.");
                }

            } catch (error) {
                console.error("Error al descargar datos:", error);
            }
        };

        descargarCSV();
    }, [coordenadaSeleccionada]);


    const handleChangelong = (event) => {
        const value = event.target.value.trim();
        setLon(value === "" ? null : value);
    };

    const handleChangeLat = (event) => {
        const value = event.target.value.trim();
        setLat(value === "" ? null : value);
    };


    const handleClick = () => {
        navigate('/map'); // Redirige a la ruta "/"
    };
    const handleClick3D = () => {
        navigate('/map3D'); // Redirige a la ruta "/"
    };

    const resetVistas = () => {
        setVisibleTablaMeteorologico(false);
        setVisibleTablaRiego(false);
        setVisibleTablaSuelo(false);
        setVisibleTablaEntorno(false);
        setVisibleTablaSalada(false);
        setVisibleTablaDulce(false);
        setVisibleTablaTesla(false);

        setVisibleGraficaDulce(false);
        setVisibleGraficaRiego(false);
        setVisibleGraficaSuelo(false);
        setVisibleGraficaEntorno(false);
        setVisibleGraficaSalada(false);
        setVisibleGraficaMeteorologico(false);
        setVisibleGraficaTesla(false);

        setVisibleTablaDulceFiltrada(false);
        setVisibleTablaRiegoFiltrada(false);
        setVisibleTablaSueloFiltrada(false);
        setVisibleTablaEntornoFiltrada(false);
        setVisibleTablaSaladaFiltrada(false);
        setVisibleTablaMeteorologicoFiltrada(false);
        setVisibleTablaTeslaFiltrada(false);

        setVisibleGraficaDulceNodo(false);
        setVisibleGraficaRiegoNodo(false);
        setVisibleGraficaSueloNodo(false);
        setVisibleGraficaEntornoNodo(false);
        setVisibleGraficaSaladaNodo(false);
        setVisibleGraficaMeteorologicoNodo(false);
        setVisibleGraficaTeslaNodo(false);
    };

    const handleMostrarPopup = () => {
        setMostrarPopup(true);
    };

    const handleSeleccionarCoord = (coord) => {
        setCoordenadaSeleccionada(coord);
        setMostrarPopup(false);
    };

    const PopupSeleccionCoordenada = ({ coordenadas, onSelect, onClose }) => (
        <div className="popup-overlay">
            <div className="popup-card">
                <div className="popup-header">
                    <h3>Selecciona nodo dulce</h3>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>
                <table className="popup-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Lat</th>
                            <th>Long</th>
                            <th>Seleccionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {coordenadas.map((coord, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{coord.lat}</td>
                                <td>{coord.lon}</td>
                                <td>
                                    <button className="select-btn" onClick={() => onSelect(coord)}>
                                        Elegir
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );


    return (
        <>
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <a className="navbar-brand ps-3" href="index.html">Multiparametric sensor</a>
                <form className="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
                    <div className="input-group">
                        <input className="form-control" type="text" placeholder="Latitud" aria-label="Latitud" aria-describedby="btnNavbarSearch" value={lat} onChange={handleChangeLat} />
                        <input className="form-control" type="text" placeholder="Longitud" aria-label="Longitud" aria-describedby="btnNavbarSearch" value={lon} onChange={handleChangelong} />
                        <button className="btn btn-primary" id="btnNavbarSearch" type="button" onClick={SearchDate}><i className="fas fa-search"></i></button>
                    </div>
                </form>
            </nav>
            <div id="layoutSidenav">
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading" id="titulo">Tables</div>
                                <button type="button" className={`btn btn-light ${botonActivo === 1 ? "active" : ""}`} onClick={() => setBotonActivo(1)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Freshwater node
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 3 ? "active" : ""}`} onClick={() => setBotonActivo(3)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Gases node
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 5 ? "active" : ""}`} onClick={() => setBotonActivo(5)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Saltwater node
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 7 ? "active" : ""}`} onClick={() => setBotonActivo(7)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Irrigation node
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 9 ? "active" : ""}`} onClick={() => setBotonActivo(9)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Meteorological node
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 11 ? "active" : ""}`} onClick={() => setBotonActivo(11)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Ground node
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 21 ? "active" : ""}`} onClick={() => setBotonActivo(21)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Tesla node
                                </button>
                            </div>

                            <div className="nav">
                                <div className="sb-sidenav-menu-heading" id="titulo">Graph</div>
                                <button type="button" className={`btn btn-light ${botonActivo === 2 ? "active" : ""}`} onClick={() => setBotonActivo(2)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Freshwater graph
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 4 ? "active" : ""}`} onClick={() => setBotonActivo(4)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Gases graph
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 6 ? "active" : ""}`} onClick={() => setBotonActivo(6)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Saltwater graph
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 8 ? "active" : ""}`} onClick={() => setBotonActivo(8)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Irrigation graph
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 10 ? "active" : ""}`} onClick={() => setBotonActivo(10)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Weather graph
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 12 ? "active" : ""}`} onClick={() => setBotonActivo(12)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Ground graph
                                </button>
                                <button type="button" className={`btn btn-light ${botonActivo === 22 ? "active" : ""}`} onClick={() => setBotonActivo(22)}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Tesla graph
                                </button>
                            </div>

                        </div>
                        <div className="sb-sidenav-footer">
                            <div className="small">MADE BY:</div>
                            miguelzaragozaesquerdo
                            @gmail.com
                        </div>
                    </nav>
                </div>
                <div id="layoutSidenav_content" className="flex-grow-1">
                    <div className='CG'>
                        {visibleTablaMeteorologicoFiltrada && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Quality</th>
                                        <th scope="col">Humidity</th>
                                        <th scope="col">Presure</th>
                                        <th scope="col">Speed</th>
                                        <th scope="col">Direction</th>
                                        <th scope="col">Precipitation</th>
                                        <th scope="col">Intensity</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(sensoresNodo?.current?.[0]) ?
                                        sensoresNodo.current[0].slice(0, 25).map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <SensoresCard value={item} />
                                            </tr>
                                        ))
                                        : (
                                            <tr>
                                                <td colSpan="4">No hay datos de nodo Salada</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaRiegoFiltrada && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Turbidity</th>
                                        <th scope="col">Salinity</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(RiegoNodo?.current?.[0]) ?
                                        RiegoNodo.current[0].slice(0, 25).map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <RiegoCard value={item} />
                                            </tr>
                                        ))
                                        : (
                                            <tr>
                                                <td colSpan="4">No hay datos de nodo Salada</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaTeslaFiltrada && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Active</th>
                                        <th scope="col">Corrent</th>
                                        <th scope="col">Voltage</th>
                                        <th scope="col">Power</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(TeslaNodo?.current?.[0]) ?
                                        TeslaNodo.current[0].slice(0, 25).map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <TeslaCard value={item} />
                                            </tr>
                                        ))
                                        : (
                                            <tr>
                                                <td colSpan="4">No hay datos de nodo Salada</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaSueloFiltrada && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Humidity</th>
                                        <th scope="col">Salinity</th>
                                        <th scope="col">Conductivity</th>
                                        <th scope="col">Air humidity</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(SueloNodo?.current?.[0]) ?
                                        SueloNodo.current[0].slice(0, 25).map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <SueloCard value={item} />
                                            </tr>
                                        ))
                                        : (
                                            <tr>
                                                <td colSpan="4">No hay datos de nodo Salada</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaEntornoFiltrada && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Propano / GLP</th>
                                        <th scope="col">Alcohol / Etanol</th>
                                        <th scope="col">Metano (CH₄)</th>
                                        <th scope="col">Butano / GLP</th>
                                        <th scope="col">Monóxido de C</th>
                                        <th scope="col">CO (alta conc.)</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(EntornoNodo?.current?.[0]) ?
                                        EntornoNodo.current[0].slice(0, 25).map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <EntornoCard value={item} />
                                            </tr>
                                        ))
                                        : (
                                            <tr>
                                                <td colSpan="4">No hay datos de nodo Salada</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaDulceFiltrada && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Turbidity</th>
                                        <th scope="col">Conductivity</th>
                                        <th scope="col">Light intensity</th>
                                        <th scope="col">Surf</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(DulceNodo?.current?.[0]) ?
                                        DulceNodo.current[0].slice(0, 25).map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <AguaDulceCard value={item} />
                                            </tr>
                                        ))
                                        : (
                                            <tr>
                                                <td colSpan="4">No hay datos de nodo Salada</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaSaladaFiltrada && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Turbidity</th>
                                        <th scope="col">Conductivity</th>
                                        <th scope="col">Light intensity</th>
                                        <th scope="col">pH</th>
                                        <th scope="col">Surf</th>
                                        <th scope="col">Salinity</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(SaladaNodo?.current?.[0]) ? (
                                        SaladaNodo.current[0].slice(0, 25).map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <AguaSaladaCard value={item} />
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4">No hay datos de nodo Salada</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaMeteorologico && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Quality</th>
                                        <th scope="col">Humidity</th>
                                        <th scope="col">Presure</th>
                                        <th scope="col">Wind Speed</th>
                                        <th scope="col">Wind Direction</th>
                                        <th scope="col">Precipitation</th>
                                        <th scope="col">Light Intensity</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sensores && sensores.current ?
                                        sensores.current.map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <SensoresCard value={item} />
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaRiego && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Turbidity</th>
                                        <th scope="col">Salinity</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Riego && Riego.current ?
                                        Riego.current.map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <RiegoCard value={item} />
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaTesla && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Active</th>
                                        <th scope="col">Corrent</th>
                                        <th scope="col">Voltage</th>
                                        <th scope="col">Power</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Tesla && Tesla.current ?
                                        Tesla.current.map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <TeslaCard value={item} />
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaSuelo && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Humidity</th>
                                        <th scope="col">Salinity</th>
                                        <th scope="col">Conductivity</th>
                                        <th scope="col">Air humidity</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Suelo && Suelo.current ?
                                        Suelo.current.map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <SueloCard value={item} />
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaEntorno && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Propano / GLP</th>
                                        <th scope="col">Alcohol / Etanol</th>
                                        <th scope="col">Metano (CH₄)</th>
                                        <th scope="col">Butano / GLP</th>
                                        <th scope="col">Monóxido de C</th>
                                        <th scope="col">CO (alta conc.)</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Entorno && Entorno.current ?
                                        Entorno.current.map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <EntornoCard value={item} />
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaDulce && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Turbidity</th>
                                        <th scope="col">Conductivity</th>
                                        <th scope="col">Light intensity</th>
                                        <th scope="col">Surf</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Dulce && Dulce.current ?
                                        Dulce.current.map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <AguaDulceCard value={item} />
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleTablaSalada && <div className='Container1'>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">lat</th>
                                        <th scope="col">long</th>
                                        <th scope="col">Temperature</th>
                                        <th scope="col">Turbidity</th>
                                        <th scope="col">Conductivity</th>
                                        <th scope="col">Light intensity</th>
                                        <th scope="col">pH</th>
                                        <th scope="col">Surf</th>
                                        <th scope="col">Salinity</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Salada && Salada.current ?
                                        Salada.current.map(item => (
                                            <tr key={item._id} item xs={12} sm={6} lg={3}>
                                                <AguaSaladaCard value={item} />
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>}</div>
                    <div className='CG'>
                        {visibleGraficaDulce && <div className='Container'>
                            <div className="Graph">
                                {Dulce && Dulce.current ?
                                    <Chart chartId="DulceGlobal" data={Dulce.current} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaTesla && <div className='Container'>
                            <div className="Graph">
                                {Tesla && Tesla.current ?
                                    <ChartTesla chartId="TeslaGlobal" data={Tesla.current} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaSalada && <div className='Container'>
                            <div className="Graph">
                                {Salada && Salada.current ?
                                    <ChartSalada chartId="SaladaGlobal" data={Salada.current} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaMeteorologico && <div className='Container'>
                            <div className="Graph">
                                {sensores && sensores.current ?
                                    <ChartMeteorologico chartId="MeteorologicoGlobal" data={sensores.current} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaRiego && <div className='Container'>
                            <div className="Graph">
                                {Riego && Riego.current ?
                                    <ChartRiego chartId="RiegoGlobal" data={Riego.current} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaEntorno && <div className='Container'>
                            <div className="Graph">
                                {Entorno && Entorno.current ?
                                    <ChartGases chartId="EntornoGlobal" data={Entorno.current} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaSuelo && <div className='Container'>
                            <div className="Graph">
                                {Suelo && Suelo.current ?
                                    <ChartSuelo chartId="SueloGlobal" data={Suelo.current} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaDulceNodo && <div className='Container'>
                            <div className="Graph">
                                {Array.isArray(DulceNodo?.current?.[0]) ?
                                    <Chart chartId="DulceNodo" data={DulceNodo.current[0].slice(0, 25)} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaSaladaNodo && <div className='Container'>
                            <div className="Graph">
                                {Array.isArray(SaladaNodo?.current?.[0]) ?
                                    <ChartSalada chartId="Salada" data={SaladaNodo.current[0].slice(0, 25)} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaTeslaNodo && <div className='Container'>
                            <div className="Graph">
                                {Array.isArray(TeslaNodo?.current?.[0]) ?
                                    <ChartTesla chartId="Tesla" data={TeslaNodo.current.slice(0, 25)} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaMeteorologicoNodo && <div className='Container'>
                            <div className="Graph">
                                {Array.isArray(sensoresNodo?.current?.[0]) ?
                                    <ChartMeteorologico chartId="Meteorologico" data={sensoresNodo.current[0].slice(0, 25)} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaRiegoNodo && <div className='Container'>
                            <div className="Graph">
                                {Array.isArray(RiegoNodo?.current?.[0]) ?
                                    <ChartRiego chartId="Riego" data={RiegoNodo.current[0].slice(0, 25)} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaEntornoNodo && <div className='Container'>
                            <div className="Graph">
                                {Array.isArray(EntornoNodo?.current?.[0]) ?
                                    <ChartGases chartId="Entorno" data={EntornoNodo.current[0].slice(0, 25)} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                    <div className='CG'>
                        {visibleGraficaSueloNodo && <div className='Container'>
                            <div className="Graph">
                                {Array.isArray(SueloNodo?.current?.[0]) ?
                                    <ChartSuelo chartId="SueloNodo" data={SueloNodo.current[0].slice(0, 25)} />
                                    : null}
                            </div>
                        </div>}
                    </div>
                </div>
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading" id="titulo">Map</div>
                                <button type="button" className="btn btn-light" onClick={handleClick}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div> Location Node
                                </button>
                                <button type="button" className="btn btn-light" onClick={handleClick3D}>
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>3D Location Node
                                </button>
                            </div>
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading" id="titulo">Export to CSV</div>
                                <button type="button" className={`btn btn-light ${botonActivo === 14 ? "active" : ""}`} onClick={handleMostrarPopup}><div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Export Data Node</button>
                                <button type="button" className={`btn btn-light`} onClick={logout}><div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>Salir</button>
                            </div>
                        </div>
                        <div className="sb-sidenav-footer">
                            <div className="small">MADE BY:</div>
                            miguelzaragozaesquerdo
                            @gmail.com
                        </div>
                    </nav>
                </div>
            </div>
            {mostrarPopup && (
                <PopupSeleccionCoordenada
                    coordenadas={Coordenadas}
                    onSelect={handleSeleccionarCoord}
                    onClose={() => setMostrarPopup(false)}
                />
            )}
        </>
    )
}

export default Home;